var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import Employees from '@/modules/search/components/filterPanels/PortePanel/Employees.vue';
import { connect } from '@/overmind';
import { json } from 'overmind';
let EmployeesContainer = class EmployeesContainer extends Vue {
    constructor() {
        super(...arguments);
        //@ts-ignore
        this.stateSliderFiltersValues = json(this.stateSliderFilters);
    }
};
__decorate([
    Prop({ default: () => { } })
], EmployeesContainer.prototype, "filter", void 0);
EmployeesContainer = __decorate([
    Component(connect(({ state: { filters: state } }) => ({
        selected: state.totalSelected.porte.employee,
        selectedRadioButton: state.selectedRadioButton.employees.queryField,
        stateSliderFilters: state.stateSliderFilters,
        selectedInputRange: state.selectedInputRange,
        errorSlider: state.errorSliderEmployees,
    }), {
        components: {
            Employees,
        },
    }))
], EmployeesContainer);
export default EmployeesContainer;
